import { useCountry } from '../../components/CountrySelector';
import { useSkippableQuery } from '../useSkippableQuery';
import { useUser } from '../useUser';
import { GET_SAVED_ITEMS_QUERY } from './savedItems.rest';

export const useSavedItems = () => {
  const { user } = useUser();
  const { country } = useCountry();
  const { data, loading, error } = useSkippableQuery(GET_SAVED_ITEMS_QUERY, {
    variables: {
      countryCode: country.alpha2Code
    },
    skip: !user.isLoggedIn
  });

  return {
    savedItems: data?.savedItems?.data || [],
    loading: loading,
    error
  };
};
